import { useCallback } from 'react';
import { maybeCopyToDashboard } from '../../ReportTemplatesManage/utils';

export function useCopyToDashboard({ report }: { report: { settings: any } }) {
	const copyToDashboard = useCallback(async () => {
		await maybeCopyToDashboard(report);
	}, [report]);

	return {
		copyToDashboard,
	};
}
